import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../lib/api";
import SwirlingMass from "../components/SwirlingMass";

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await resetPassword({ token, password });
      nav("/interview", { replace: true });
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "That did not work. Ask for a new link.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="reset-password-page" className="grain relative h-full overflow-hidden">
      <div className="absolute inset-0 opacity-60">
        <SwirlingMass density={5000} intensity={0.5} />
      </div>
      <div className="relative flex h-full items-center justify-center px-6">
        <form onSubmit={submit} className="w-full max-w-sm">
          <p className="label">Covalence / Sphere</p>
          <h1 className="mt-5 font-display text-3xl leading-tight tracking-tight">
            Set a new password.
          </h1>
          <p className="mt-5 text-sm leading-relaxed text-zinc-400">
            Everywhere else you were signed in will be signed out.
          </p>
          <input
            data-testid="reset-password-input"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="at least 10 characters"
            className="mt-8 w-full border border-[var(--line-hi)] bg-[#0a0a0d] px-4 py-3 font-data text-[12px] text-zinc-100 outline-none placeholder:text-zinc-700"
          />
          <button
            type="submit"
            data-testid="reset-password-submit"
            disabled={busy || password.length < 10}
            className="btn-stark mt-5 w-full justify-center !py-3 disabled:opacity-40"
          >
            {busy ? "Setting it" : "Set password and continue"}
          </button>
          {err && (
            <p data-testid="reset-password-error" className="mt-4 font-data text-[11px] text-zinc-300">
              — {err}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
